import React, { useState, useEffect } from "react";
import "./EventsList.css";
import { getCalendar } from "../../../../../api/api";

const EventsList = ({ currentDate, dateRange, selectedView }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        setLoading(true);
        const { startDate, endDate } = dateRange;

        // Форматируем даты в нужный формат для API
        const dateFrom = startDate.toISOString().split("T")[0];
        const dateTo = endDate.toISOString().split("T")[0];

        const data = await getCalendar(dateFrom, dateTo);

        // Фильтруем события и преобразуем их в нужный формат
        const eventsList = data
          .filter((day) => day.event_name)
          .map((day) => ({
            date: day.date, // оставляем дату как строку
            name: day.event_name,
            type: !day.workday_flag ? "Праздник" : "Мероприятие",
            isHoliday: !day.workday_flag,
          }))
          .sort((a, b) => new Date(a.date) - new Date(b.date));

        setEvents(eventsList);
      } catch (error) {
        console.error("Ошибка при загрузке событий:", error);
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, [dateRange]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
    });
  };

  const getViewTitle = () => {
    switch (selectedView) {
      case "day":
        return "Праздники и мероприятия на день";
      case "week":
        return "Праздники и мероприятия на неделю";
      case "month":
        return "Праздники и мероприятия на месяц";
      default:
        return "Праздники и мероприятия";
    }
  };

  if (loading) {
    return (
      <div className="events-list__loading">Загрузка данных о событиях...</div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="events-list__empty">
        Нет праздников и мероприятий за этот период
      </div>
    );
  }

  return (
    <div className="events-list">
      <h3 className="events-list__title">{getViewTitle()}</h3>
      <div className="events-list__content">
        {events.map((event, index) => (
          <div
            key={index}
            className={`events-list__item ${
              event.isHoliday ? "holiday" : "event"
            }`}
          >
            <div className="events-list__date-info">
              <span className="events-list__date">
                {formatDate(event.date)}
              </span>
              <span className="events-list__type">{event.type}</span>
            </div>
            <div className="events-list__event-info">
              <span className="events-list__event-name">{event.name}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventsList;
